import styled, { css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledSaveDraftSignalButton = styled(IconButton)`
    ${({ isLoading, iconSize }) =>
        isLoading &&
        css`
            background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};

            svg {
                width: ${iconSize} !important;
                height: ${iconSize} !important;
            }
        `};
`;
